export default {
    BranchMap: {
        route_header_title: 'Şubeler',
        branch_detail_action_button: 'Tüm Şubeleri Göster',
        branch_detail_layout_right_button: 'Şubeyi Seç',
        branch_list_layout_right_button: 'Şubeyi Seç',
        branch_list_bottom_sheet_header: 'ŞUBELER',
        branch_list_bottom_sheet_header_button: 'Haritada Göster',
        location_permission_toast_message:
            'Konum izni vererek yakındakileri\ngörmek ister misin?',
        location_provider_error_toast_message: 'Cihazın konum ayarı kapalı',
        location_permission_toast_chip_label: 'İzin Ver',
    },
    Packages: {
        right_info_title: 'Abonelikler/Paketler',
        right_info_description:
            'Paketler sayfasında satışta olan paket ve abonelikleri görüntüleyebilir, arayabilir, şubeye veya türe göre filtreleyebilirsin. Bir pakete dokunduğunda içindeki avantajları ve geçerli olduğu şubeleri görebilirsin.',
        route_header_title: 'Abonelikler/Paketler',
        content_header_title: 'Abonelikler/Paketler',
        content_header_description:
            'Abonelik ve paket seçeneklerini keşfet, hemen satın al',
        search_field_placeholder: 'Abonelik/Paket ara',
        category_chip_all: 'Tümü',
        category_chip_subscription: 'Abonelikler',
        category_chip_package: 'Paketler',
        branch_filter_chip_label: '{{branchName}}',
        branch_sheet_title: 'Şube Seç',
        branch_sheet_description: 'Paketleri şubeye göre filtrele.',
        branch_sheet_clear_button: 'Filtreyi Temizle',
        branch_sheet_empty_title: 'Şube Bulunamadı',
        branch_sheet_empty_description: 'Bu şirkete ait şube bulunamadı.',
        empty_sheet_title: 'Paket Bulunamadı',
        empty_sheet_description:
            'Bu şirkete ait abonelik veya paket bulunamadı',
        empty_sheet_description_filtered:
            'Aramanla eşleşen paket yok. Filtreleri değiştirip tekrar dene.',
    },
    PackageDetails: {
        search_field_placeholder: 'Avantaj ara',
        sheet_title: 'Paket Detayı',
        sheet_description: 'Paketin içeriğini ve avantajlarını incele.',
        sheet_title_subscription: 'Abonelik Detayı',
        sheet_description_subscription:
            'Aboneliğin içeriğini ve avantajlarını incele.',
        benefits_section_title: 'Avantajlar',
        filter_limited: 'Limitli',
        filter_limitless: 'Limitsiz',
        filter_out_of_scope: 'Kapsam Dışı',
        branch_section_title: 'Şube',
        branch_section_placeholder: 'Şube seç',
        branch_section_change_chip_label: 'Değiştir',
        select_branch_error_toast_message:
            'Devam etmek için bir şube seçmelisin.',
        footer_section_submit_button_label: 'Devam Et',
        empty_benefits_title: 'Avantaj Bulunamadı',
        empty_benefits_description:
            'Bu filtreye uyan avantaj yok. Başka bir filtre dene.',
    },
    PackagePayment: {
        right_info_title: 'Satın Alma',
        right_info_description:
            'Bu sayfada paketin başlangıç tarihini ve adedini belirleyip ödemeye geçebilirsin. Ödeme adımında cüzdan bakiyen kullanılır; bakiyen yetmezse yükleme yapabilirsin.',
        route_header_title: 'Satın Al',
        content_header_title: 'Satın Alma Özeti',
        content_header_description: 'Bilgileri kontrol et ve ödemeye geç.',
        details_section_title: 'Paket',
        details_section_branch_label: 'Şube',
        details_section_details_chip_label: 'Detay',
        select_date_section_title: 'Başlangıç',
        select_date_section_when_first_used_toast_message:
            'Paket ilk kullanımında başlar.',
        select_date_section_immediately_toast_message:
            'Paket satın alır almaz başlar.',
        select_date_section_now_label: 'Şimdi başlat ({{today}})',
        select_date_section_planed_label: 'Planlı tarih ({{formattedDate}})',
        select_date_section_change_chip_label: 'Değiştir',
        quantity_section_title: 'Adet',
        submit_button_label: 'Ödemeye Geç',
        action_button_cancel_title: 'Vazgeç',
        cancel_alert_title: 'Satın almadan çıkılsın mı?',
        cancel_alert_message: 'Girdiğin bilgiler kaybolacak.',
        cancel_alert_approve_button: 'Çık',
        cancel_alert_cancel_button: 'Devam Et',
        warning_alert_title: 'Uyarı',
        warning_alert_reject: 'Tamam',
        toast_error_message: 'Satın alma tamamlanamadı. Tekrar dene.',
    },
    PackageUsageHistory: {
        content_header_title: 'Kullanım Geçmişi',
        content_header_description:
            'Abonelik ve paketlerinle yaptığın harcamaları görüntüle',
        search_field_placeholder: 'Ara',
        filter_button_label: 'Filtrele',
        empty_sheet_title: 'İşlem Bulunamadı',
        empty_sheet_description:
            'Abonelik veya paket kapsamında yapılmış bir harcaman bulunmuyor',
        category_chip_subscription: 'Abonelik',
        category_chip_package: 'Paket',
    },
    PackageUsageHistoryDetail: {
        content_header_title: 'İşlem Detayı',
        content_header_description:
            'Tüm işlem detaylarına buradan kolayca ulaşabilirsin',
        transaction_details: 'İŞLEM BİLGİLERİ',
        branch_details: 'FİRMA BİLGİLERİ',
        additional_details: 'DETAY BİLGİLER',
        process_type: 'İşlem Tipi',
        package_usage: 'Paket Kullanımı',
        subscription_usage: 'Abonelik Kullanımı',
        spent_amount: 'Harcama Miktarı',
        covered_by_package: 'Paketten Karşılanan',
        covered_by_subscription: 'Abonelik İndirimi',
        paid_amount: 'Ödenen Tutar',
        date: 'Tarih',
        branch_name: 'Şube Adı',
        description: 'Açıklama',
        package: 'Paket',
        subscription: 'Abonelik',
        package_name: 'Paket Adı',
        tag_qr_name: 'Tag QR Adı',
    },
    PackageUsageHistoryFilter: {
        content_header_title: 'Kullanımları Filtrele',
        content_header_description:
            'Gerekli filtrelemeleri yap ve sonuçlara kolayca ulaş',
        package_label: 'Paket/Abonelik',
        package_placeholder: 'Paket veya abonelik seçin',
        package_step_title: 'Paket/Abonelik Seçimi',
        package_step_description:
            'Kullanımlarını görmek istediğin paketi veya aboneliği seç',
        package_clear_button: 'Seçimi Temizle',
        package_empty_title: 'Paket Bulunamadı',
        package_empty_description: 'Aktif bir abonelik veya paket bulunamadı',
        categories: 'KATEGORİ',
        category_chip_all: 'Tümü',
        category_chip_subscription: 'Abonelik',
        category_chip_package: 'Paket',
        date: 'TARİH ARALIĞI',
        start_date_label: 'Başlangıç Tarihi',
        end_date_label: 'Bitiş Tarihi',
        date_time_placeholder: 'Örn. 07/07/2023',
        submit: 'Sonuçları Göster',
    },
    PurchasedPackages: {
        category_chip_usage_history: 'Kullanım Geçmişi',
        card_detail_button_label: 'Detay',
        right_info_title: 'Abonelikler/Paketler',
        right_info_description:
            'Bu sayfada satın aldığın paket ve aboneliklerin listesini, kalan kullanım haklarını ve geçerlilik tarihlerini görebilirsin. Bir karta dokunarak detayları inceleyebilir veya aboneliğini iptal edebilirsin.',
        route_header_title: 'Abonelikler/Paketler',
        content_header_title: 'Abonelikler/Paketler',
        content_header_description:
            'Aboneliklerinin ve paketlerinin listesini buradan görüntüleyebilirsin.',
        category_chip_all: 'Tümü',
        category_chip_subscription: 'Abonelik',
        category_chip_package: 'Paket',
        empty_sheet_title: 'Abonelik Yok',
        empty_sheet_description: 'Aktif bir abonelik veya paket bulunamadı.',
        empty_sheet_subscription_description: 'Aktif bir abonelik bulunamadı.',
        empty_sheet_package_description: 'Aktif bir paket bulunamadı.',
    },
    PurchasedPackageDetails: {
        sheet_title: 'Abonelik Detayları',
        sheet_title_package: 'Paket Detayları',
        sheet_description: 'Aboneliğinin kullanımlarını ve detaylarını incele.',
        sheet_description_package:
            'Paketinin kullanımlarını ve detaylarını incele.',
        benefits_section_title: 'PAKETİN KULLANIMLARI',
        participation_title: 'Detay Bilgiler',
        subscription_cancel_button_title: 'İptal Et',
        package_cancel_button_title: 'İptal Et',
        subscription_general_info_title: 'GENEL BİLGİLER',
        subscription_general_info_total_earned_discount_title: 'Toplam Kazanç',
        subscription_general_info_start_date_title: 'Baş. Tar.',
        subscription_general_info_end_date_title: 'Bitiş Tar.',
        subscription_general_info_total_usage_count_title: 'Toplam Kullanım',
        empty_benefits_title: 'Kullanım Bulunamadı',
        empty_benefits_description:
            'Bu filtreye uyan kullanım yok. Başka bir filtre dene.',
    },
    PurchasedPackageCancel: {
        title: 'Abonelik İptal Özeti',
        title_package: 'Paket İptal Özeti',
        description: 'Abonelik detaylarına aşağıdan erişebilirsin.',
        description_package: 'Paket detaylarına aşağıdan erişebilirsin.',
        subscription_subtitle: 'ABONELİK DETAYLARI',
        package_subtitle: 'PAKET DETAYLARI',
        subscription_amount_label: 'İade edilebilir tutar',
        subscription_usage_date_label: 'Kullanılan gün sayısı',
        subscription_remaining_label: 'Toplam gün sayısı',
        date_label: 'gün',
        no_refund_description:
            'Bu abonelik için iade yapılmayacak. İptal ettiğinde kullanım hakların sona erer.',
        no_refund_description_package:
            'Bu paket için iade yapılmayacak. İptal ettiğinde kullanım hakların sona erer.',
        cancel_button_title: 'İptal Et',
        close_button_title: 'Kapat',
        alert_provider_success_message: 'Abonelik başarıyla iptal edildi',
        alert_provider_success_message_package: 'Paket başarıyla iptal edildi',
        alert_provider_success_message_description:
            'Abonelik iptal işleminin detaylarını görüntülemek için cüzdan hareketlerini kontrol edebilirsin',
        alert_provider_success_message_description_package:
            'Paket iptal işleminin detaylarını görüntülemek için cüzdan hareketlerini kontrol edebilirsin',
        alert_provider_success_message_button: 'Tamam',
        toast_error_message: 'İptal işlemi tamamlanamadı. Tekrar dene.',
    },
    utils: {
        Package: {
            period_daily: 'Günlük',
            period_weekly: 'Haftalık',
            period_monthly: 'Aylık',
            limit_unlimited_label: 'Sınırsız',
            limit_remaining_usage_label: 'Kalan Kullanım',
            limit_remaining_label: 'Kalan',
            status_active: 'Aktif',
            status_upcoming: 'Başlamadı',
            status_expired: 'Süresi Geçti',
            benefit_description:
                'Kullanım haklarına ek olarak, {{name}} hizmetinden {{limit}} kez faydalanabilirsiniz.',
            benefit_unlimited_description:
                'Kullanım haklarına ek olarak, {{name}} hizmetinden sınırsız kez faydalanabilirsiniz.',
            benefit_out_of_scope_description:
                '{{name}} hizmeti bu paketin kapsamında olmadığı için faydalanamazsınız.',
        },
    },
}
